import * as React from 'react';
import { Box, Flex } from '../Layout';
import { Text } from 'ilenia';
import { StyleSheet, css } from 'aphrodite';
import { Common } from '../../Assets/styles/common';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label: string;
}

export const Checkbox: React.SFC<CheckboxProps> = (props) => {
    const { id, label, disabled, ...rest } = props;
    return (
        <Box mt={16} pl={20} pr={20}>
            <Flex flexDirection="row-reversed" alignItems="center">
                <input
                    type="checkbox"
                    className={css(
                        styles.checkbox,
                        styles.checkboxPseudo,
                    )}
                    id={id}
                    disabled={disabled}
                    {...rest}
                />
                <label
                    htmlFor={id}
                    className={css(
                        styles.label,
                        disabled && styles.labelDisabled,
                    )}
                >
                    <Text id={label!}/>
                </label>
            </Flex>
        </Box>
    );
};

const styles = StyleSheet.create({
    checkbox: {
        WebkitAppearance: 'none',
        width: '16px',
        height: '16px',
        borderRadius: '3px',
        boxShadow: Common.Borders.boxShadowHover,
        backgroundColor: Common.Color.lightTextColor,
        border: Common.Borders.border,
        cursor: 'pointer',
    },
    checkboxPseudo: {
        ':hover': {
            boxShadow: '0 -1px 2px 0 rgba(0, 0, 0, 0.13), inset 0 1px 3px 0 rgba(0, 0, 0, 0.13)',
        },
        ':checked:after': {
            content: '""',
            position: 'absolute',
            background: 'white',
            marginLeft: '3px',
            marginTop: '6px',
            width: '2px',
            height: '2px',
            boxShadow: `
            2px 0 0 white,
            3px 0 0 white,
            3px -1px 0 white,
            3px -3px 0 white,
            3px -5px 0 white,
            3px -7px 0 white`,
            transform: 'rotate(45deg)'
        },
        ':checked': {
            boxShadow: '0 0px 0px 0 rgba(0, 0, 0, 0.17)',
            backgroundColor: Common.Color.buttonBackground,
            border: `solid 1px ${Common.Color.buttonBackground}`
        },
        ':checked:hover': {
            boxShadow: '0 -1px 2px 0 rgba(0, 0, 0, 0.13), inset 0 1px 3px 0 rgba(0, 0, 0, 0.13)',
        },
        ':checked:focus': {
            backgroundColor: '#2471b3',
            border: 'solid 1px #2471b3'
        },
        ':focus': {
            boxShadow: '0 -1px 3px 0 rgba(0, 0, 0, 0.17)',
            outline: '0px'
        },
        ':disabled': {
            backgroundColor: '#f8f8f8',
        },
    },
    label: {
        font: Common.Font.normalText,
        cursor: 'pointer',
        userSelect: 'none',
        lineHeight: '1.43',
        marginLeft: '9px',
    },
    labelDisabled: {
        color: '#535353',
    }
});
